import { render, staticRenderFns } from "./HotPsList.vue?vue&type=template&id=ca42e2cc&scoped=true&"
import script from "./HotPsList.vue?vue&type=script&lang=js&"
export * from "./HotPsList.vue?vue&type=script&lang=js&"
import style0 from "./HotPsList.vue?vue&type=style&index=0&id=ca42e2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca42e2cc",
  null
  
)

export default component.exports